import { Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { DeletePurposeConfirmation } from './DeletePurposeConfirmation';

import { ModalSection } from '../../../../Shared/components-v2/modal-section/ModalSection';
import { ModalSectionRow } from '../../../../Shared/components-v2/modal-section/ModalSectionRow';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { EnvelopeAccountSettingsModalQuery } from '../graphql/accountSettingsModal.generated';

type ManagedAccount = EnvelopeAccountSettingsModalQuery['envelopeAccount'] & { __typename: 'ManagedAccount' };
type CashAccount = EnvelopeAccountSettingsModalQuery['envelopeAccount'] & { __typename: 'CashAccount' };

type Props = {
  envelopeAccount: ManagedAccount | CashAccount;
};

export const PurposeSection: React.FC<Props> = ({ envelopeAccount }) => {
  const {
    legacyGoalId,
    envelope: { purpose },
  } = envelopeAccount;
  const currentPath = window.location.pathname;
  const editPurposeUrl = urlBuilder.appGoalsEditPurpose.absolute({ goal_id: legacyGoalId, return_to: currentPath });

  const isRetirementPurpose =
    purpose && (purpose.__typename === 'PurposeRetirementGrowth' || purpose.__typename === 'PurposeRetirementIncome');

  const canDeletePurpose =
    !isRetirementPurpose &&
    (envelopeAccount.__typename === 'ManagedAccount' || envelopeAccount.__typename === 'CashAccount');

  return purpose ? (
    <ModalSection header="Goal">
      <ModalSectionRow>
        <ModalSectionRow.LeadingContent>
          <Text>Assigned to</Text>
        </ModalSectionRow.LeadingContent>
        <ModalSectionRow.TrailingContent>
          <Text>{purpose.name}</Text>
          {canDeletePurpose && (
            <DeletePurposeConfirmation
              purposeId={purpose.id}
              accountId={envelopeAccount.id}
              purposeName={purpose.name}
              accountName={envelopeAccount.name}
              variant="AccountSettings"
            />
          )}
        </ModalSectionRow.TrailingContent>
      </ModalSectionRow>
    </ModalSection>
  ) : (
    <ModalSection header="Goal" cta={<SambaAutoLink to={editPurposeUrl}>Add to a goal</SambaAutoLink>}>
      <ModalSectionRow>
        <ModalSectionRow.LeadingContent>
          <Text>Assign this account to a goal for additional advice on how to save.</Text>
        </ModalSectionRow.LeadingContent>
      </ModalSectionRow>
    </ModalSection>
  );
};
